<template>

    <label for="file-download">
        <img src="../../assets/download.png">
    </label>

</template>

<script>

</script>

<style scoped>
  img {
    position: absolute;
    margin-top: -16px;
    width: 20px;
    height: 20px;
  }

  input {
    margin: 0;
    padding: 0;
  }

  label {
    padding: 0;
    cursor: pointer;
    margin: 0;
    display: inline-block;
  }
</style>